// Components
import { BaseImage } from '../BaseImage'
import { BaseDialogVerification } from '../BaseDialogVerification'

// Interfaces
import { IBaseDialogAlertProps } from './interfaces'

// i18n
import { useTranslation } from 'react-i18next'

const BaseDialogAlert = ({
  isOpen,
  type,
  isUsingSecondButton,
  firstButtonLabel,
  secondButtonLabel,
  footer,
  closable,
  label,
  subLabel,
  isUsingDefaultFooter,
  onFirstButtonClick,
  onSecondButtonClick,
  onButtonCloseClick,
  onAfterClose,
  isHorizontalFooter,
}: IBaseDialogAlertProps) => {
  // Hook
  const { t } = useTranslation()

  /**
   * @description Render header
   *
   * @return {JSX.Element} JSX.Element
   */
  const renderHeader = (): JSX.Element => {
    switch (type) {
      case 'success':
        return <BaseImage isIcon isSvg icon="icon-success" />
      default:
        return <></>
    }
  }

  /**
   * @description Render body
   *
   * @return {JSX.Element} JSX.Element
   */
  const renderBody = (): JSX.Element => {
    return (
      <div className="my-8">
        {label && <p className="font-16 font-weight-700 text-grey-font">{t(label)}</p>}
        {subLabel && <p className="font-16 font-weight-400 text-grey-font">{t(subLabel)}</p>}
      </div>
    )
  }

  return (
    <BaseDialogVerification
      isOpen={isOpen}
      header={renderHeader()}
      body={renderBody()}
      onFirstButtonClick={onFirstButtonClick}
      onSecondButtonClick={onSecondButtonClick}
      onButtonCloseClick={onButtonCloseClick}
      onAfterClose={onAfterClose}
      firstButtonLabel={firstButtonLabel}
      secondButtonLabel={secondButtonLabel}
      isUsingSecondButton={isUsingSecondButton}
      closable={closable}
      footer={footer}
      isUsingDefaultFooter={isUsingDefaultFooter}
      isHorizontalFooter={isHorizontalFooter}
    />
  )
}

BaseDialogAlert.defaultProps = {
  isUsingSecondButton: false,
  closable: true,
  isUsingDefaultFooter: true,
}

export { BaseDialogAlert }
